import { upperFirst } from 'lodash-es';
import type { EmitType } from '@mts-fe/types';
import { treeEmits } from '..';

export const useTreeEvents = (emit: EmitType, callback?: EmitType) =>
  treeEmits.reduce(
    (acc, evt) =>
      Object.assign(acc, {
        [`on${upperFirst(evt)}`]: (...args) => (callback?.(evt, ...args), emit(evt, ...args)),
      }),
    {} as Recordable<Function>,
  );
